import { useController } from '../state/context';
import { Bomb, Gem } from './Icons';

/** Восемь искр, разлетающихся из открытой клетки; углы фиксированы, дальность чередуется. */
const SPARKS = Array.from({ length: 8 }, (_, k) => ({ a: k * 45, d: k % 2 ? 46 : 62 }));

export function Grid() {
  const c = useController();
  const game = c.game.value;
  const fx = c.fx.value;
  const thinking = c.busy.value;
  const classes = ['grid', thinking ? 'thinking' : '', fx.boom ? 'boom' : ''].filter(Boolean).join(' ');
  return (
    <div class={thinking ? 'board thinking' : 'board'}>
      <ul class={classes} aria-label="Слова на поле" data-testid="grid">
        {game?.words.map((word, i) => {
          const role = game.roles[i] ?? 'd';
          const revealed = game.revealed[i] ?? false;
          const tag = role === 'b' ? (revealed ? '💥' : '') : revealed && role === 't' ? '✓' : '';
          const cls = [
            'tile',
            role,
            revealed ? 'rev' : '',
            fx.pop === i ? 'pop' : '',
            word.length > 8 ? 'long' : '',
          ]
            .filter(Boolean)
            .join(' ');
          return (
            // slot: вход «раздачей карт» играет один раз и не мешается с анимациями самой плитки
            <li class="slot" style={{ '--i': i }} key={`${game.id}-${i}`}>
              <div
                class={cls}
                data-testid="tile"
                data-index={i}
                data-word={word}
                data-role={role}
                data-revealed={revealed}
              >
                {role !== 'd' && (
                  <span class="mark" aria-hidden="true">
                    {role === 'b' ? <Bomb /> : <Gem />}
                  </span>
                )}
                {tag && <span class="tag">{tag}</span>}
                <span class="word">{word}</span>
                {role === 't' &&
                  SPARKS.map((s) => (
                    <i class="spark" key={s.a} style={{ '--a': `${s.a}deg`, '--d': `${s.d}px` }} />
                  ))}
              </div>
            </li>
          );
        })}
      </ul>
      <div class="scan" aria-hidden="true" />
    </div>
  );
}
